import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import  Boost from 'highcharts/modules/boost'
import  More from 'highcharts/highcharts-more'
import  noData from 'highcharts/modules/no-data-to-display'
import  threed from 'highcharts/highcharts-3d'
import HC_exporting from 'highcharts/modules/exporting';
import { VlDataService } from '../../vl-data/vl-data.service';
import { WidgetType, widgetType_Chart_Mapping, widgetType_Data_Mapping } from '../../shared-configs/chart.config'
import { Subscription } from 'rxjs';
import { HighchartsRendererService } from '../../shared_services/highcharts-renderer.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiconfigService } from '../../apiconfig/apiconfig.service';
HC_exporting(Highcharts);
(Boost as any)(Highcharts);
(More as any)(Highcharts);
(noData as any)(Highcharts);
(threed as any)(Highcharts);
@Component({
  selector: 'vl-highcharts-renderer',
  templateUrl: './highcharts-renderer.component.html',
  styleUrls: ['./highcharts-renderer.component.scss']
})
export class HighchartsRendererComponent implements OnInit ,OnChanges{

  Highcharts: typeof Highcharts = Highcharts;
  HighChart!: Highcharts.Chart;
  chartOptions: any;
  @Input() height!: number;
  @Input() width!: number;
  @Input() widgetConfig!: any;
  @Input() widgetData!: any;
  @Input() widgetType!: WidgetType;
  chartConfig!: any;
  dataPresent = false;
  updateChart = false;
  ischartLoaded = false;
  subScriptions: Subscription[] = [];
  constructor(private dataService: VlDataService,private hichartService: HighchartsRendererService,private http:HttpClient,private apiConfigService:ApiconfigService) { }


 async ngOnInit() {
    Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
        chart:{
          height:this.height
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"]
                }
            }
        },
        legend:{
            itemStyle: {
                    width:50,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                }  
        }
    });
    this.chartConfig = this.dataService.deepClone(widgetType_Chart_Mapping[this.widgetType]);
    let datasource = this.widgetData.widgetDataSource;
      if(datasource && !this.widgetData.widgetConfig['chartDataSourceData']){
        await this.getApiOrEntityDefinitionBasedOnForm(datasource.datasourceType,datasource.datasource);
      }
    const chartDataSourceData = this.widgetConfig.chartDataSourceData;
    const chartConfig = this.widgetConfig.chartConfig;
    if(!chartConfig || !chartDataSourceData) {
      this.chartOptions = widgetType_Data_Mapping[this.widgetType];
      this.ischartLoaded = true;
    }
    else {
      this.chartOptions = this.hichartService.transoformSourceDataToChartData(chartDataSourceData,chartConfig,this.widgetType);
      this.ischartLoaded = true;
    }
    this.subscriberEvents();
  }

  ngOnChanges(changes: SimpleChanges): void {
      if(changes['height']){
        console.log(this.height,'height');
        Highcharts.setOptions({
          lang: {
            thousandsSep: ','
          },
          chart:{
            height:this.height
          },
          exporting: {
              buttons: {
                  contextButton: {
                      menuItems: ["downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"]
                  }
              }
          },
          legend:{
              itemStyle: {
                      width:50,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden'
                  }  
          }
      });

  this.updateChart = true;

      }
  }

  subscriberEvents() {
    const configSubscriber: any = this.hichartService.displayWidgetDataConfigSubscriber$.subscribe((event: any) => {
      if(event) {
        this.updateChart = true;
        const chartDataSourceData = this.widgetConfig.chartDataSourceData;
        const chartConfig = this.widgetConfig.chartConfig;
        if(chartConfig && chartDataSourceData) {
          this.chartOptions = widgetType_Data_Mapping[this.widgetType];
          this.chartOptions = this.hichartService.transoformSourceDataToChartData(chartDataSourceData,chartConfig, this.widgetType);
        }
      }
    })
    
    this.subScriptions.push(configSubscriber);
  }

  async getApiOrEntityDefinitionBasedOnForm(type: string, selectedId: string) {
    try {
      let userApis = this.apiConfigService.getUserApis().apis;
      if (type === "api") {
        let api = userApis.find((item: any) => item.apiId == selectedId);
      let responce = await  this.makeChartDataSourceApiRequest(
          api.apiURL,
          api.method,
          api.requestBody,
          api.headers,
          api.apiId
        );
        this.handleResponse(responce);
      } else if (type === "entity") {
        const entityId = selectedId;
        const entitySubmissionData = await this.hichartService.getEntitySubmissionData(entityId).toPromise();
        this.handleResponse(entitySubmissionData);
      
      }
    } catch (error: any) {
    }
  }



 async  makeChartDataSourceApiRequest(
    apiUrl: string,
    method: string,
    requestData: any,
    headers: HttpHeaders,
    apiId?: string
  ) {
    const requestOptions = { headers };
    let requestObservable;

    switch (method) {
      case "GET":
        requestObservable = this.http.get(apiUrl, requestOptions).toPromise()
        break;
      case "POST":
        requestObservable = await this.http.post(apiUrl, requestData, requestOptions).toPromise()
        break;
      default:
        throw new Error("Invalid HTTP method");
    }

    return requestObservable;
  }



  handleResponse(resposne: any) {
    this.widgetData.widgetConfig['chartDataSourceData'] = resposne;
  }


  ngOnDestroy() {
    for (const subscription of this.subScriptions) {
      subscription.unsubscribe();
    }  
  }
}
